/*
 *@Description: 批量修改
 *@ComponentAuthor: Xu Jian
*/
<template>
  <div>
    <el-dialog lock-scroll
                @close="close"
               :modal-append-to-body="false"
               :append-to-body="true"
               :close-on-click-modal="false"
               :visible.sync="visible"
               width="900px" >
      <template slot="title">
        <div class="edit-title">{{ $lang('批量编辑') }} <span>{{ $lang('请勾选你要批量修改的字段') }}</span></div>
      </template>
      <div class="overflow">
        <el-form class="el-form-edit" ref="sizeForm" :inline="true" :model="formData" label-position="left" label-suffix=" :" style="height:300px;">
          <el-form-item prop="type">
            <template slot="label">
               <el-checkbox v-model="editState.goods.checked" @change="checkChange($event,'type')">{{ $lang('物品类型') }}</el-checkbox>
            </template>
             <Base-Select v-model="formData.goods" :props="{label:'name',value:'name', res:'appArticleTypeVOList',valueObj:true}"
                       dicUrl="/vip/baseData/list"   :placeholder="$lang('请选择')" :disabled="!editState.goods.checked"></Base-Select>
          </el-form-item>
          <el-form-item prop="name">
            <template slot="label">
               <el-checkbox v-model="editState.goodsName.checked" @change="checkChange($event,'type')">{{ $lang('物品名称') }}</el-checkbox>
            </template>
            <el-input v-model="formData.goodsName" :placeholder="$lang('请输入')" :disabled="!editState.goodsName.checked" :minlength="1" :maxlength="20"></el-input>
          </el-form-item>
          <el-form-item prop="weight">
            <template slot="label">
               <el-checkbox v-model="editState.packageTotalWeight.checked" @change="checkChange($event,'type')">{{ $lang('物品重量') }}</el-checkbox>
            </template>
            <el-input-number v-model="formData.packageTotalWeight" :label="$lang('描述文字')" :precision="2" :disabled="!editState.packageTotalWeight.checked" :min="0" :max="999.99"></el-input-number>
          </el-form-item>
          <el-form-item prop="pay">
            <template slot="label">
               <el-checkbox v-model="editState.payment.checked" @change="checkChange($event,'type')">{{ $lang('结算方式') }}</el-checkbox>
            </template>
             <Base-Select v-model="formData.payment" :props="{label:'name',value:'code', res:'appPaymentMannerVOList',valueObj:true}"
                    dicUrl="/vip/baseData/list"  :placeholder="$lang('请选择')" :disabled="!editState.payment.checked">
                </Base-Select>
            <!-- <Base-Select v-model="formData.payment" :disabled="!editState.payment.checked" :dic="DIC.payTypes" :placeholder="$lang('请选择')"  :props="{label:'name',value:'code',valueObj:true}"></Base-Select> -->
          </el-form-item>
          <el-form-item prop="box">
            <template slot="label">
               <el-checkbox v-model="editState.boxStandard.checked" @change="checkChange($event,'type')">{{ $lang('箱子规格') }}</el-checkbox>
            </template>
            <Base-Select v-model="formData.boxStandard"
                         :disabled="!editState.boxStandard.checked"
                         :props="{label:'name',value:'id', res:'records',valueObj:true}"
                         dicUrl="/vip/material/getMaterialSalesPrice"
                         :placeholder="$lang('请选择')">
            </Base-Select>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button @click="close">{{$lang('取 消')}}</el-button>
        <el-button type="primary" @click="submit">{{$lang('提 交')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS, DIC } from '@constants'
import { mapGetters } from 'vuex'
export default {
  name: 'BatchEdit',
  props: {
    value: {},
    spotType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      data: '',
      DIC,
      visible: false,
      formData: {
        goods: '',
        goodsName: '',
        packageNumber: '',
        packageTotalWeight: '',
        payment: '',
        boxStandard: '',
        declaredValue: '',
      },
      editState: {
        goods: {
          checked: false,
          key: 'goods',
        },
        goodsName: {
          checked: false,
          key: 'goodsName',
        },
        packageNumber: {
          checked: false,
          key: 'packageNumber',
        },
        packageTotalWeight: {
          checked: false,
          key: 'packageTotalWeight',
        },
        payment: {
          checked: false,
          key: 'payment',
        },
        boxStandard: {
          checked: false,
          key: 'boxStandard',
        },
        declaredValue: {
          checked: false,
          key: 'declaredValue',
        },
      },
      rules: {},
    }
  },
  watch: {
    value: {
      handler(val) {
        this.visible = val
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  created() {
  },
  mounted() {
  },
  methods: {
    checkChange(value, data) {
      console.log(value, data)
    },
    async getTestResult() {
      const { code, data, msg } = {}
      if (code === RESPONSE_SUCCESS) {
        this.testData = data
      } else {
        this.testData.msg = msg
        this.$message.error(this.$lang(msg))
      }
    },
    close() {
      this.visible = false
      this.$emit('input', this.visible)
      this.$emit('change', this.visible)
    },
    submit() {
      this.$emit('update', { formData: this.formData, editState: this.editState })
    },
  },
}
</script>

<style scoped lang="scss" scoped>
.edit-title{
  font-size: 16px;
  color: #333;
  font-weight: bold;
  span{
    font-size: 12px;
    color: #999;
    font-weight: normal;
  }
}

</style>
